import { useState, useRef, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { useTheme } from '@mui/material/styles';
import {
    Avatar, Box, Chip, ClickAwayListener, Divider, Grid, List, ListItemButton, ListItemIcon, ListItemText, Paper,
    Popper, Stack, Typography, Select, MenuItem, FormControl
} from '@mui/material';

// third-party
import PerfectScrollbar from 'react-perfect-scrollbar';

// project imports
import MainCard from 'ui-component/cards/MainCard';
import Transitions from 'ui-component/extended/Transitions';
import User1 from 'assets/images/users/user-round.svg';

// assets
import { IconLogout, IconSettings } from '@tabler/icons';
import EmailOutlinedIcon from '@mui/icons-material/EmailOutlined';
import CalendarTodayOutlinedIcon from '@mui/icons-material/CalendarTodayOutlined';
import FilterVintageOutlinedIcon from '@mui/icons-material/FilterVintageOutlined';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import moment from "moment"

import useAuth from "../../../../routes/Hooks/useAuth";

import { connect } from "react-redux"
import { updateprofilr, formadmin } from "../../../../store/action"

import { women, man } from "../../../../constants/images"
import DateAdapter from '@mui/lab/AdapterMoment';
import LocalizationProvider from '@mui/lab/LocalizationProvider';
import DatePicker from '@mui/lab/DatePicker';
import { useSnackbar } from 'notistack';
// ==============================|| PROFILE MENU ||============================== //

const ProfileSection = (props) => {

    var days = 4749;
    var newdate = new Date(Date.now() - days * 24 * 60 * 60 * 1000)
    const d = new Date(newdate);
    const formatdate = moment(d).format('YYYY-MM-DD');

    const theme = useTheme();
    const customization = useSelector((state) => state.customization);
    const navigate = useNavigate();

    const [sdm, setSdm] = useState(true);
    const [value, setValue] = useState('');
    const [notification, setNotification] = useState(false);
    const [selectedIndex, setSelectedIndex] = useState(-1);
    const [open, setOpen] = useState(false);

    let { setAuth, auth } = useAuth()
    let user = auth?.User


    const anchorRef = useRef(null);
    const handleLogout = async () => {

        setAuth({});
        navigate("/MyHussain/login");
        localStorage.removeItem("Uid")
        localStorage.removeItem('pop_status');
        window.location.reload()

    };

    const handleClose = (event) => {
        if (anchorRef.current && anchorRef.current.contains(event.target)) {
            return;
        }
        setOpen(false);
    };

    const handleListItemClick = (event, index, route = '') => {
        setSelectedIndex(index);
        handleClose(event);

        if (route && route !== '') {
            navigate(route);
        }
    };
    const handleToggle = () => {
        setOpen((prevOpen) => !prevOpen);
    };

    const prevOpen = useRef(open);
    useEffect(() => {
        if (prevOpen.current === true && open === false) {
            anchorRef.current.focus();
        }

        prevOpen.current = open;
    }, [open]);



    var age = moment().diff(user?.dob, 'years', false);



    const [visible, Setvisible] = useState(false)
    const [username, setusername] = useState(user?.name)
    const [DOBS, setDOBS] = useState(user?.dob)
    const [gender, setgender] = useState(user?.gender)
    console.log('date of', user?.dob)


    let photoUrl = user?.photoURL != undefined ? user?.photoURL : user?.gender == "male" ? man.default : women.default
    const { enqueueSnackbar } = useSnackbar();


    return (
        <>
            <Chip
                sx={{
                    height: '48px',
                    alignItems: 'center',
                    borderRadius: '27px',
                    transition: 'all .2s ease-in-out',
                    borderColor: theme.palette.primary.light,
                    backgroundColor: theme.palette.primary.light,
                    '&[aria-controls="menu-list-grow"], &:hover': {
                        borderColor: theme.palette.primary.main,
                        background: `${theme.palette.primary.main}!important`,
                        color: theme.palette.primary.light,
                        '& svg': {
                            stroke: theme.palette.primary.light
                        }
                    },
                    '& .MuiChip-label': {
                        lineHeight: 0
                    }
                }}
                icon={
                    <Avatar
                        src={photoUrl}
                        sx={{
                            ...theme.typography.mediumAvatar,
                            margin: '8px 0 8px 8px !important',
                            cursor: 'pointer'
                        }}
                        ref={anchorRef}
                        aria-controls={open ? 'menu-list-grow' : undefined}
                        aria-haspopup="true"
                        color="inherit"
                    />
                }
                label={<IconSettings stroke={1.5} size="1.5rem" color={theme.palette.primary.main} />}
                variant="outlined"
                ref={anchorRef}
                aria-controls={open ? 'menu-list-grow' : undefined}
                aria-haspopup="true"
                onClick={handleToggle}
                color="primary"
            />
            <Popper
                placement="bottom-end"
                open={open}
                anchorEl={anchorRef.current}
                role={undefined}
                transition
                disablePortal
                popperOptions={{
                    modifiers: [
                        {
                            name: 'offset',
                            options: {
                                offset: [0, 14]
                            }
                        }
                    ]
                }}
            >
                {({ TransitionProps }) => (
                    <Transitions in={open} {...TransitionProps}>
                        <Paper>
                            <ClickAwayListener onClickAway={handleClose}>
                                <MainCard border={false} elevation={16} content={false} boxShadow shadow={theme.shadows[16]}>
                                    <Box sx={{ p: 2 }}>
                                        <Stack>
                                            <Stack direction="row" spacing={0.5} alignItems="center">
                                                <Typography variant="h4">Assalam O Alaikum ,</Typography>
                                                <Typography component="span" variant="h4" sx={{ fontWeight: 400 }}>
                                                    {user?.name}
                                                </Typography>
                                            </Stack>
                                            <Typography variant="subtitle2">{user?.usertype}</Typography>
                                        </Stack>

                                        <Divider />
                                    </Box>
                                    <PerfectScrollbar style={{ height: '100%', maxHeight: 'calc(100vh - 250px)', overflowX: 'hidden' }}>
                                        <Box sx={{ p: 2 }}>

                                            <List
                                                component="nav"
                                                sx={{
                                                    width: '100%',
                                                    maxWidth: 350,
                                                    minWidth: 300,
                                                    backgroundColor: theme.palette.background.paper,
                                                    borderRadius: '10px',
                                                    [theme.breakpoints.down('md')]: {
                                                        minWidth: '100%'
                                                    },
                                                    '& .MuiListItemButton-root': {
                                                        mt: 0.5
                                                    }
                                                }}
                                            >
                                                <ListItemButton
                                                    sx={{ borderRadius: `${customization.borderRadius}px` }}
                                                    selected={selectedIndex === 1}

                                                >
                                                    <ListItemIcon>
                                                        <EmailOutlinedIcon stroke={1.5} size="1.3rem" />
                                                    </ListItemIcon>
                                                    <ListItemText
                                                        primary={
                                                            <Grid container spacing={1} justifyContent="space-between">
                                                                <Grid item>
                                                                    <Typography variant="body2">Email : {user?.email}</Typography>
                                                                </Grid>

                                                            </Grid>
                                                        }
                                                    />
                                                </ListItemButton>
                                                <ListItemButton
                                                    sx={{ borderRadius: `${customization.borderRadius}px` }}
                                                    selected={selectedIndex === 1}

                                                >
                                                    <ListItemIcon>
                                                        <CalendarTodayOutlinedIcon stroke={1.5} size="1.3rem" />
                                                    </ListItemIcon>
                                                    <ListItemText
                                                        primary={
                                                            <Grid container spacing={1} justifyContent="space-between">
                                                                <Grid item>
                                                                    <Typography variant="body2">DOB : {user?.dob}</Typography>
                                                                </Grid>

                                                            </Grid>
                                                        }
                                                    />
                                                </ListItemButton>
                                                <ListItemButton
                                                    sx={{ borderRadius: `${customization.borderRadius}px` }}
                                                    selected={selectedIndex === 1}

                                                >
                                                    <ListItemIcon>
                                                        <FilterVintageOutlinedIcon stroke={1.5} size="1.3rem" />
                                                    </ListItemIcon>
                                                    <ListItemText
                                                        primary={
                                                            <Grid container spacing={1} justifyContent="space-between">
                                                                <Grid item>
                                                                    <Typography variant="body2"> Age : {age}</Typography>
                                                                </Grid>

                                                            </Grid>
                                                        }
                                                    />
                                                </ListItemButton>
                                                <ListItemButton
                                                    sx={{ borderRadius: `${customization.borderRadius}px` }}
                                                    selected={selectedIndex === 0}
                                                    onClick={() => Setvisible(true)}
                                                >
                                                    <ListItemIcon>
                                                        <IconSettings stroke={1.5} size="1.3rem" />
                                                    </ListItemIcon>
                                                    <ListItemText primary={<Typography variant="body2">Account Settings</Typography>} />
                                                </ListItemButton>



                                                <ListItemButton
                                                    sx={{ borderRadius: `${customization.borderRadius}px` }}
                                                    selected={selectedIndex === 4}
                                                    onClick={handleLogout}
                                                >
                                                    <ListItemIcon>
                                                        <IconLogout stroke={1.5} size="1.3rem" />
                                                    </ListItemIcon>
                                                    <ListItemText primary={<Typography variant="body2">Logout</Typography>} />
                                                </ListItemButton>
                                            </List>
                                        </Box>
                                    </PerfectScrollbar>
                                </MainCard>
                            </ClickAwayListener>
                        </Paper>
                    </Transitions>
                )}
            </Popper>


            <Dialog open={visible} onClose={() => Setvisible(false)}>
                <DialogTitle>
                    <h1>Edit Profile</h1>
                </DialogTitle>
                <DialogContent>
                    <Box sx={{ display: 'flex', flexWrap: 'wrap' }}>

                        <TextField
                            label="Name"
                            id="standard-start-adornment"
                            fullWidth
                            variant="standard"
                            color="error"
                            onChange={(event) => setusername(event.target.value)}
                            type={'text'}
                            value={username}
                        />

                        {/* <Typography style={{ marginTop: 20 }}>
                            Date Of Birth
                        </Typography> */}

                        {/* <TextField
                            value={DOBS}
                            id="standard-start-adornment"
                            fullWidth
                            variant="standard"
                            color="error"
                            onChange={(event) => setDOBS(event.target.value)}
                            type="date"

                        /> */}

                        {/* <LocalizationProvider dateAdapter={DateAdapter}>
                            <DatePicker
                                maxDate={moment(formatdate)}
                                value={DOBS}
                                onChange={(newValue) => {
                                    setDOBS(newValue);
                                }}
                                renderInput={(params) => <TextField {...params} 
                                id="standard-start-adornment"
                                fullWidth
                                variant="standard"
                                color="error"
                                     />
                                }
                                style={{ border: 0 }}
                            />
                        </LocalizationProvider> */}

                        <FormControl sx={{ ...theme.typography.customInput }} style={{ width: '100%',marginTop:30 }}>
                            <Select
                                labelId="demo-simple-select-label"
                                id="outlined-adornment-email-register"
                                name="gender"
                                fullWidth
                                variant="standard"
                                color="error"
                                value={gender}
                                onChange={(event) => setgender(event.target.value)}

                            >
                                <MenuItem value={"male"}>Male</MenuItem>
                                <MenuItem value={"female"}>Female</MenuItem>

                            </Select>

                        </FormControl>


                    </Box>

                </DialogContent>

                <DialogActions>
                    <Button variant="outlined" color="error" onClick={() => Setvisible(false)} >Cancel</Button>
                    <Button variant="outlined" color="error" onClick={() => props.updateprofilr(username, gender, Setvisible, user,enqueueSnackbar)}>Save Changes</Button>
                </DialogActions>
            </Dialog>


        </>
    );
};



const mapDispatchToProps = dispatch => ({
    updateprofilr: (username, gender, Setvisible, user,enqueueSnackbar) => dispatch(updateprofilr(username, gender, Setvisible, user,enqueueSnackbar)),

})

export default connect(null, mapDispatchToProps)(ProfileSection);

